import React from 'react'
import { AiFillGithub } from "react-icons/ai";
import { CgWebsite } from "react-icons/cg";
import proImg1 from '../../images/proj-1 1.png'
import proImg2 from '../../images/proj-2 1.png'
import proImg3 from '../../images/proj-3 1.png'
import proImg4 from '../../images/pro-1-1.png'
import proImg5 from '../../images/email-temp.png'
import proImg6 from '../../images/proj-6 1.png'
import proImg7 from '../../images/context-api.png'
import proImg8 from '../../images/router-pro.png'

function ProjectCompo() {
    const portfoiloData = [
        {
            img: proImg1,
            projectSource: "https://github.com/Tripti2016/managelanding.git",
            websiteLink: "https://managelanding-six.vercel.app/",
        },
        {
            img: proImg4,
            projectSource: "https://github.com/Tripti2016/hulu-clone.git",
            websiteLink: "https://hulu-clone-seven-blond.vercel.app/",
        },
        {
            img: proImg7,
            projectSource: "https://github.com/Tripti2016/context-api.git",
            websiteLink: "https://context-api-inky.vercel.app/",
        },
        {
            img: proImg2,
            projectSource: "https://github.com/Tripti2016/React2.git",
            websiteLink: "https://react2-gamma.vercel.app/",
        },
        {
            img: proImg3,
            projectSource: "https://github.com/Tripti2016/comfy.git",
            websiteLink: "https://comfyprj.netlify.app/",
        },

       
        {
            img: proImg6,
            projectSource: "https://github.com/Tripti2016/Quiz.git",
            websiteLink: "https://quiz-gamma-five.vercel.app/",
        },
        {
            img: proImg5,
            projectSource: "https://github.com/Tripti2016/Email-template.git",
            websiteLink: "https://66a2b8c9a8ec45b16592e3a8--courageous-biscotti-b84d2d.netlify.app/",
        },
        {
            img: proImg8,
            projectSource: "https://github.com/Tripti2016/react-router.git",
            websiteLink: "https://react-router-self.vercel.app/",
        },
    ];
    return (
        <div>
            <div className="dummy-pro-page">

                <div className="portfolios">
                    {portfoiloData.map((item, index) => (
                        <div className="portfolio-item" key={index}>
                            <div className="image pro-img">
                                <span className='border-top'></span>
                                <span className='border-right'></span>
                                {/* <img src={item.img} alt="" width={500} height={100} /> */}
                                <img src={item.img} alt="" />
                                <span className='border-bottom'></span>
                                <span className='border-left'></span>
                            </div>
                            <div className="hover-item">
                                <h3>Project Source</h3>
                                <div className="icons">
                                    <a href={item.projectSource} target="_blank" className="icon">
                                        <AiFillGithub />
                                    </a>
                                    <a href={item.websiteLink} className="icon" target="_blank">
                                        <CgWebsite />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default ProjectCompo
